import React from 'react';
import { Link } from 'react-router-dom';
import '../infrastructure.css';

export default function InfraCTA() {
  return (
    <div className="infra-closing" data-testid="infra-cta">
      <h2 className="infra-closing-headline">Ready to get started?</h2>
      <p className="infra-closing-desc">Explore the platform or talk to our team about the use case that fits your business.</p>
      <div style={{ display: 'flex', gap: 14, justifyContent: 'center' }}>
        <Link to="/login" className="infra-btn-primary">Get started</Link>
        <a href="mailto:hello@thcohq.com" className="infra-btn-secondary" style={{ borderColor: '#E5E7EB', color: '#212121' }}>Contact sales</a>
      </div>
    </div>
  );
}
